import { isNil } from 'lodash-es'

class AnimationUtils {
  static shouldAnimateIn(propertyName, state) {
    if (!propertyName) throw new Error('method `shouldAnimateIn` argument required.')
    if (!state[propertyName]) throw new Error(`property: ${propertyName} not found in object 'state'.`)
    const result = (state[propertyName].show === true
      && state[propertyName].shown === false
      && state[propertyName].animating === false)

    // If the animation should happen, set
    // animation flag to `true`
    if (result) Object.assign(state[propertyName], { animating: true })

    return result
  }

  static setDefaultState(show = false) {
    return { show, shown: show, animating: false }
  }

  static setStateFlags(setTrueArr = [], state = {}) {
    Object.keys(state).forEach((key) => {
      if (!isNil(state[key].show)) {
        if (setTrueArr.indexOf(key) >= 0) Object.assign(state[key], { show: true, shown: true, animating: false })
        else Object.assign(state[key], { show: false, shown: false, animating: false })
      }
    })
  }

  static setStateFlagsFalse(propArr = [], state = {}) {
    Object.keys(state).forEach((key) => {
      if (!isNil(state[key].show)) {
        if (propArr.indexOf(key) >= 0) Object.assign(state[key], { show: false, shown: false, animating: false })
      }
    })
  }

  static setStateFlagsTrue(propArr = [], state = {}) {
    Object.keys(state).forEach((key) => {
      if (!isNil(state[key].show)) {
        if (propArr.indexOf(key) >= 0) Object.assign(state[key], { show: true, shown: true, animating: false })
      }
    })
  }
}

export default AnimationUtils
